import React from 'react'
import PropTypes from "prop-types";

const PaymentSummary = ({ lotsWon, lotTotal, deliveryChosen, deliveryCharge, amountPledged, totalToPay }) => {

    const lotRows = lotsWon.map(lot => (
        <tr key={lot.lotId}>
            <td>
                {lot.lotTitle}
            </td>
            <td>
                {lot.dateTimeOfWinningBid}
            </td>
            <td>
                {lot.amountAsBritishCurrency}
            </td>
        </tr>
    ));  


    return (
        <div id="paymentTableWrapper">
            <table border="1" className="table">                
                <thead>
                    <tr>
                        <th scope="col">Lot</th>
                        <th scope="col">Bid Time</th>
                        <th scope="col">Bid Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {lotRows}
                </tbody>
                <tfoot>
                    {lotsWon.length > 0 ? (
                     <>
                        <tr>
                            <td>
                            </td>
                            <th>
                                Lot Total
                            </th>
                            <td>
                               {lotTotal}
                            </td>
                        </tr>
                        <tr>
                            <td>
                            </td>
                            <th>
                                Lot Delivery Total
                            </th>
                            <td>
                                {deliveryChosen ? deliveryCharge: "£0"}
                            </td>
                            </tr>
                      </>
                    ) : (
                            <></>
                        )}
                    {amountPledged ? (
                        <tr>
                            <td>
                            </td>
                            <th>
                                Total Pledged
                            </th>
                            <td>
                                {amountPledged}
                            </td>
                        </tr>
                    ): (
                            <></>
                        )}
                    <tr>
                        <td>
                        </td>
                        <th>
                            Total to Pay
                        </th>
                        <td>
                            {totalToPay}
                        </td>
                    </tr>                    
                </tfoot>
            </table>
        </div>);
};

PaymentSummary.propTypes = {
    lotsWon: PropTypes.array.isRequired,
    totalToPay: PropTypes.string.isRequired,
    amountPledged: PropTypes.string.isRequired,
    deliveryCharge: PropTypes.string.isRequired,
    deliveryChosen: PropTypes.bool.isRequired,
    lotTotal: PropTypes.string.isRequired
}

export default PaymentSummary;
